import i18n from '@/i18n'
import { AssetFamilyTypeId } from '@/types/hierarchy/asset-family-type-id.enum'

export function getEnergyConsumerType(type: AssetFamilyTypeId): string {
  const { t } = i18n.global

  switch (type) {
    case AssetFamilyTypeId.ResidentialEnergyConsumer:
      return t('energyConsumers.types.residential')
    case AssetFamilyTypeId.CommercialEnergyConsumer:
      return t('energyConsumers.types.commercial')
    case AssetFamilyTypeId.IndustrialEnergyConsumer:
      return t('energyConsumers.types.industrial')
    case AssetFamilyTypeId.MixedEnergyConsumer:
      return t('energyConsumers.types.mixed')
    case AssetFamilyTypeId.SiteNetConsumption:
      return t('energyConsumers.types.siteNetConsumption')
    case AssetFamilyTypeId.SiteTotalConsumption:
      return t('energyConsumers.types.siteTotalConsumption')
    default:
      return t('words.unknown')
  }
}

export function isEnergyConsumer(assetFamilyTypeId: AssetFamilyTypeId): boolean {
  const consumerTypes = [
    AssetFamilyTypeId.ResidentialEnergyConsumer,
    AssetFamilyTypeId.CommercialEnergyConsumer,
    AssetFamilyTypeId.IndustrialEnergyConsumer,
    AssetFamilyTypeId.MixedEnergyConsumer,
    AssetFamilyTypeId.SiteNetConsumption,
    AssetFamilyTypeId.SiteTotalConsumption,
  ]
  return consumerTypes.includes(assetFamilyTypeId)
}
